// extracted by mini-css-extract-plugin
export default {"card":"contentCard_card__lJbtW","transparent":"contentCard_transparent__r5D4L"};